module.exports = __webpack_public_path__ + "static/media/hazard.0050aff4.PNG";